import { Command } from 'commander';
import chalk from 'chalk';
import { createSkillsFindCommand } from './find.js';
import { createSkillsAddCommand } from './add.js';
import { createSkillsListCommand } from './list.js';
import { createSkillsInfoCommand } from './info.js';
import { createSkillsSyncCommand } from './sync.js';
import { createSkillsInspectCommand } from './inspect.js';
import { getCliName } from '../../utils/cli-name.js';

function showSkillsHelp(): void {
    const cli = getCliName();
    console.log(chalk.bold.cyan('🛠 ' + cli + ' skills') + chalk.dim(' - Quản lý agent skills'));
    console.log();
    console.log(chalk.bold('Các lệnh:'));
    console.log(`  ${chalk.cyan('find')}     Tìm kiếm skills trên server hoặc npm`);
    console.log(`  ${chalk.cyan('add')}      Cài đặt skill vào .jai1/skills/`);
    console.log(`  ${chalk.cyan('list')}     Liệt kê skills đã cài hoặc có sẵn`);
    console.log(`  ${chalk.cyan('info')}     Xem chi tiết một skill`);
    console.log(`  ${chalk.cyan('inspect')}  Đọc chi tiết candidate mà không cài đặt`);
    console.log(`  ${chalk.cyan('sync')}     Đồng bộ skills sang các IDE`);
    console.log();
    console.log(chalk.bold('Ví dụ:'));
    console.log(chalk.dim(`  $ ${cli} skills find audit`));
    console.log(chalk.dim(`  $ ${cli} skills find "react" --skillsh`));
    console.log(chalk.dim(`  $ ${cli} skills add brainstorming`));
    console.log(chalk.dim(`  $ ${cli} skills add vercel/next-skills --skillsh`));
    console.log(chalk.dim(`  $ ${cli} skills list`));
    console.log(chalk.dim(`  $ ${cli} skills sync --all -y`));
    console.log();
    console.log(chalk.dim(`Chạy "${cli} skills <lệnh> --help" để xem chi tiết`));
}

export function createSkillsCommand(): Command {
    const cmd = new Command('skills')
        .alias('s')
        .description('Manage agent skills (search, install, sync to IDEs)')
        .action(() => {
            showSkillsHelp();
        });

    cmd.addCommand(createSkillsFindCommand());
    cmd.addCommand(createSkillsAddCommand());
    cmd.addCommand(createSkillsListCommand());
    cmd.addCommand(createSkillsInfoCommand());
    cmd.addCommand(createSkillsInspectCommand());
    cmd.addCommand(createSkillsSyncCommand());

    return cmd;
}
